import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, NavigationExtras } from '@angular/router';
import { AuthenticationService } from 'app/services/auth.service';

@Injectable()
export class AuthGuard  {
  private router = inject(Router);
  private auth = inject(AuthenticationService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isLoggedIn) return true;
    const extras: NavigationExtras = {};
    if (state.url !== '/welcome') {
      extras.queryParams = { returnUrl: state.url };
    }
    this.router.navigate(['/sessioncheck'], extras);
    return false;
  }

}
